<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form
        ref="queryEvalProjectForm"
        :model="queryEvalProjectForm"
        label-width="80px"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="所属分类">
              <el-select
                v-model="queryEvalProjectForm.categoryId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-button type="primary" @click="getEvalProjectList"
              >查询</el-button
            >
            <el-button type="primary" @click="addCtiy">创建</el-button>
            <!-- <el-button type="primary">批量导出</el-button> -->
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="value" label="编号"> </el-table-column>
        <el-table-column prop="name" label="物品评估信息模板名称">
        </el-table-column>
        <el-table-column prop="categoryName" label="所属分类">
        </el-table-column>
        <el-table-column prop="status" label="前端展示">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">展示</span>
            <span v-else>不展示</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              @click="editEvalProject(scope.row)"
              type="text"
              size="small"
              >编辑</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 1)"
              type="text"
              size="small"
              v-if="scope.row.status === 0"
              >展示</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 0)"
              type="text"
              size="small"
              style="color: red;"
              v-else
              >不展示</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, scope.$index - 1)"
              type="text"
              size="small"
              v-if="scope.$index > 0"
              >上移</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, scope.$index + 1)"
              type="text"
              size="small"
              v-if="scope.$index < tableData.length - 1"
              >下移</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, 0, true)"
              type="text"
              size="small"
              >置顶</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, -1, true)"
              type="text"
              size="small"
              >置底</el-button
            >
            <el-button @click="deleteEvaluationTemplate(scope.row.id)" type="text" size="small" style="color: red;">删除</el-button> 
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog
      :title="
        dlgType === 'change' ? '编辑物品信息评估模板' : '新建物品信息评估模板'
      "
      :visible.sync="isDlg"
      width="700px"
    >
      <div style="margin: 20px;">
        <div>
          <el-form
            ref="editEvalProjectForm"
            :model="editEvalProjectForm"
            :rules="editorFormRules"
            label-width="120px"
          >
            <el-form-item label="编号" v-if="dlgType === 'change'">
              <el-input
                clearable
                v-model="editEvalProjectForm.value"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="所属分类" prop="categoryId">
              <el-select
                v-model="editEvalProjectForm.categoryId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="模板名称" prop="name">
              <el-input clearable v-model="editEvalProjectForm.name"></el-input>
            </el-form-item>
            <el-form-item label="评估内容" prop="multipleChoice">
              <el-checkbox-group v-model="checkList">
                <el-checkbox
                  v-for="item in itemOptionsArray"
                  :label="item.id"
                  :key="item.id"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button
            type="primary"
            style="margin: 30px 20px;"
            @click="submitEditor"
            >确定</el-button
          >
          <el-button style="margin: 10px 20px;" @click="closeEditormodelDlg"
            >暂不</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      // 查询数据
      queryEvalProjectForm: {
        categoryId: null,
      },
      itemOptionsArray: this.global.itemOptions,
      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      checkList: [],

      // 新建编辑对话框数据
      isDlg: false,
      editEvalProjectForm: {
        id: null,
        value: null,
        name: null,
        categoryId: null,
        templateKey: null,
        type: 1,
      },

      editorFormRules: {
        name: [
          { required: true, message: "请输入模板名称", trigger: "change" },
        ],
        categoryId: [
          { required: true, message: "请输入所属分类", trigger: "change" },
        ],
        checkList: [
          { required: true, message: "请选择评估内容", trigger: "change" },
        ],
      },

      dlgType: "change",

      loading: false,

      categoryOptions: [],
    };
  },
  watch: {},
  computed: {},
  methods: {
    deleteEvaluationTemplate(id){
      let self = this
      self.$confirm('是否删除').then(() => {
         self.$api.deleteEvaluationTemplate({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getEvalProjectList()
          }
      })
      })
     
    },
    getCategory() {
      let self = this;
      self.$api
        .getClass({
          typeKey: "category",
          status: 1,
          page: 1,
          size: 100000,
        })
        .then((res) => {
          self.categoryOptions = res.data.records || [];
        });
    },
    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getEvalProjectList();
    },

    // 获取表格数据
    getEvalProjectList() {
      let self = this;
      self.$api
        .templateListSearch({
          type: 1,
          page: self.currentPage,
          size: self.pageSize,
          categoryId: self.queryEvalProjectForm.categoryId,
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },

    // 添加
    addCtiy() {
      this.dlgType = "new";
      this.editEvalProjectForm = {};
      this.$nextTick(()=>{
          this.$refs['editEvalProjectForm'].clearValidate()
      })
      this.checkList = [];
      this.isDlg = true;
    },

    // 修改
    editEvalProject(row) {
      let self = this;
      self.editEvalProjectForm = {};
      self.dlgType = "change";
      self.editEvalProjectForm = row;
      self.checkList = row.templateKey.split(","); //字符串按逗号分隔成数组
      self.isDlg = true;
    },

    // 关闭编辑对话框
    closeEditormodelDlg() {
      this.isDlg = false;
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs["editEvalProjectForm"].validate((valid) => {
        if (valid) {
          let params = this.editEvalProjectForm;
          params.templateKey = self.checkList.join(",");
          params.type = 1;
          self.$api.updateEvaluationTemplate(params).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              self.getEvalProjectList();
              self.closeEditormodelDlg();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    changeStatus(row, newStatus) {
      let self = this;
      row.status = newStatus;
      self.$api.updateEvaluationTemplate(row).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          self.getEvalProjectList();
        }
      });
    },
    upDownMove(id, toIndex, type) {
      let self = this;
      self.$api
        .evaluationTemplateSwap({
          currentId: id,
          swapId: type ? toIndex : self.tableData[toIndex].id,
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "移动成功",
              type: "success",
            });
            self.getEvalProjectList();
          }
        });
    },
  },
  created() {},
  mounted() {
    let self = this;
    self.getEvalProjectList();
    self.getCategory();
  },
};
</script>
<style lang="less" scoped></style>
